export { default } from './SectionText';
